import { services } from '@qompium/pages-helper-tools';
import * as apiClient from './apiClient';
import { Profile } from '../models';

const profileServiceUrl = services.profiles;

export async function getProfile(userId: string) {
  return await apiClient.getFirst<Profile>(profileServiceUrl, `?id=${userId}`);
}
